import { React, useState, useEffect } from "react";
import {
  Modal,
  Button,
  FormControl,
  FormGroup,
  InputGroup,
} from "react-bootstrap";
import $ from "jquery";
import axios from "axios";
import PreLoad from "./PreLoad";
import { user_id, role_id, pcp_user_id } from "../CurrentUser";
import { useToasts } from "react-toast-notifications";
require("dotenv").config();
export default function ContractModal(props) {
  const { show, handlemodal, contractid } = props;
  const [error, setError] = useState(props.error);
  const [loading, setLoading] = useState(false);
  const { addToast } = useToasts();
  const handleClose = () => {
    handlemodal();
  };

  const save = () => {
    let deletereason = $("#deletereason").val();
    if (deletereason.length <= 0) {
      addToast("Enter a valid reason", {
        appearance: "error",
        autoDismiss: true,
      });
    }
    setLoading(true);
    const formData = new FormData();
    formData.append("pcp_user_id", pcp_user_id);
    formData.append("role_id", role_id);
    formData.append("user_id", user_id);
    formData.append("ContractID", contractid);
    formData.append("DeletionReason", deletereason);

    const headers = {
      "Content-Type": "application/json",
    };
    axios
      .post(
        process.env.REACT_APP_APP_URL + "/contract/deletecontracts",
        formData,

        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.success == 0) {
          setError(response.data.message);
        } else if (response.data.success == 1) {
          handlemodal();
        }
      })
      .catch((error) => {
        setLoading(false);
        setError(error);
        handlemodal();
      });
  };

  return (
    <div>
      <PreLoad loading={loading} />
      <div>
        <Modal show={show}>
          <Modal.Header>
            <Modal.Title> Contract Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger">
              <i className="fa fa-exclamation-triangle"></i>&nbsp;
              <span>Are you sure you want to Delete selected Contracts?</span>
            </div>
            <FormGroup>
              <InputGroup>
                <InputGroup>
                  <InputGroup>Enter reason for deleting contract(s)</InputGroup>
                </InputGroup>
                <FormControl
                  as="textarea"
                  id="deletereason"
                  aria-label="With textarea"
                  required={true}
                  placeholder="Contract deleting reason"
                />
              </InputGroup>
              <small className="help-block text-danger">
                * Reason for deleting contract(s). Minimum 20 character
              </small>
              <br />
              <small className="help-block text-danger">{error}</small>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={save}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
